import MaterialPropertyAssigner from "../../../output/assets/materials/material-property-assigner.js";

const ValidProperties = new Set(["side", "skinning", "morphTargets"]);

const DefaultValues = {
    side: THREE.FrontSide,
    skinning: false,
    morphTargets: false,
};

const UpdatingProps = new Set(["skinning", "morphTargets"]);

class ThreeGLRaycastMaterialPropertyAssigner extends MaterialPropertyAssigner {
    constructor() {
        super();
    }

    setProperty(material, property, newValue) {
        if (!ValidProperties.has(property)) return;

        if (newValue === undefined) newValue = DefaultValues[property];

        if (UpdatingProps.has(property)) {
            let oldValue = material[property];
            if (oldValue === undefined) oldValue = DefaultValues[property];

            if (newValue !== oldValue) {
                material.needsUpdate = true;
            }
        }

        material[property] = newValue;
    }
}

export default ThreeGLRaycastMaterialPropertyAssigner;
